import { init } from '../../audio/MidiController';
import {
    AudioSink,
    AudioSource,
    MidiSink,
    MidiSource,
} from '../../audio/routing';
import RydHeaderDialogBox from '.././widgets/RydHeaderDialogBox';
import './MidiDeviceSelectionDialog.css';
import '../midi/MidiDevicePanel.css';
import '../pickers/ContextTonality.css';
import React from 'react';
import { normalizeClassName } from '../../render/renderUtils';
import { useMidiAccessStore } from '../../stores/MidiAccessStore';

function requiresMidi<T extends AudioSink | AudioSource>(device?: T): boolean {
    if (!device) {
        return false;
    }
    const r = device instanceof MidiSink || device instanceof MidiSource;
    return r;
}

function MidiDeviceSelectionDialog<T extends AudioSink | AudioSource>({
    selected,
    listSource,
    setCB,
    collapsedClass
}: {
    selected?: T,
    listSource: (midiAccess: any) => T[],
    setCB: (s?: T) => void,
    collapsedClass?: string
}) {

    const [collapsed, setCollapsed] = React.useState(true);
    const midiAccessStore = useMidiAccessStore();
    const hasMidiAccess = midiAccessStore.midiAccess != null;

    if (collapsed) {
        const classes : string[] = [];
        const label = selected ? selected.displayName : '---';
        if (requiresMidi(selected) && !hasMidiAccess) {
            classes.push('ryd-midi--error');
        }
        return (
            <button
                className={normalizeClassName(classes.concat([!collapsedClass ? '' : collapsedClass]))}
                onClick={() => setCollapsed(false)}>{label}</button>
        );
    }

    return (<RydHeaderDialogBox closeCB={() => { setCollapsed(true) }}>
        <ul className={normalizeClassName(['midi-device-panel--list'])}>
            <li key={'__default__'}
                className={normalizeClassName(['ryd-button-option'].concat(!selected ? ['ryd-button-option--active'] : []))}
                onClick={() => {
                    setCB(undefined);
                    setCollapsed(true);
                }}>
                ---
            </li>
            {listSource(midiAccessStore.midiAccess).map((sink, idx) => {
                const classes = ['ryd-button-option'];
                if (sink.id === selected?.id) {
                    classes.push('ryd-button-option--active');
                }
                return (
                    <li key={idx}
                        className={normalizeClassName(classes)}
                        onClick={() => {
                            setCB(sink);
                            setCollapsed(true);
                        }}>
                        {sink.displayName}
                    </li>
                );
            })}
            {!hasMidiAccess && <div>Refresh MIDI access to see devices<br />
                <RydGrantMidiPermissionsButton setMIDIAccess={midiAccessStore.setMidiAccess} />
            </div>}
        </ul>
    </RydHeaderDialogBox>);
}

export function RydGrantMidiPermissionsButton({
    setMIDIAccess
}: {
    setMIDIAccess: (midiAccess: any) => void
}
) {
    return <button onClick={() => init(setMIDIAccess)}>Grant MIDI permissions</button>;
}

export {
    MidiDeviceSelectionDialog
};